var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.getEventHandlers}},[_vm._v("Refresh")]),_c('DataTable',{attrs:{"rowKeys":['name'],"rows":_vm.eventHandlers,"actions":_vm.readOnly
        ? [
            {
              name: 'eventHandler',
              label: 'View',
              params: {
                name: 'eventHandlerName'
              }
            }
          ]
        : [
            {
              name: 'eventHandler',
              label: 'View',
              params: {
                name: 'eventHandlerName'
              }
            },
            {
              name: 'eventHandlerEdit',
              label: 'Edit',
              params: {
                name: 'eventHandlerName'
              }
            }
          ],"columns":[
      { name: 'name', type: 'text' },
      { name: 'event', type: 'text' },
      { name: 'active', type: 'boolean' },
      { name: 'condition', type: 'text' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }